export const passwordConfig = {
  minLength: 8,
  requirements: {
    minNumbers: 1,
    minLetters: 1,
  },
};

export const validatePassword = (password: string) => {
  const hasMinLength = password.length >= passwordConfig.minLength;
  const hasNumbers = /\d/.test(password);
  const hasLetters = /[a-zA-Z]/.test(password);

  const errors: string[] = [];

  if (!hasMinLength) {
    errors.push(
      `Password must be at least ${passwordConfig.minLength} characters long`
    );
  }
  if (!hasNumbers) {
    errors.push('Password must contain at least one number');
  }
  if (!hasLetters) {
    errors.push('Password must contain at least one letter');
  }

  return {
    isValid: errors.length === 0,
    errors,
    strength: (hasMinLength && hasNumbers && hasLetters ? 'strong' : 'weak') as
      | 'strong'
      | 'weak',
  };
};
